var React = require('react');
var labels = require('MemberJoinLabels');
var { $form, $simpleSelect, $input } = require('~/../../src/Foundation/ReactForms/Code/Scripts/React/Validation/ValidationComponents.jsx');

class Agreements extends React.Component {
    constructor(props) {
        super(props);

        this.handleInputChange = this.handleInputChange.bind(this);
    }

    handleInputChange(event) {
        this.props.updateStepState(event.target.name, event.target.checked);
    }

    render() {
        return <div className={"agreements-container"}>
            <div className={"row"}>
                <div className={"panel"}>
                    <div className={"col-md-12"}>
                        <h3>{labels.step5.agreements}</h3>
                    </div>
                    <div className={"edit"}>
                        <div className={"col-md-8"}>
                            <div>
                                <input type="checkbox" id="agreement1" name="agreement1" checked={this.props.stepState.agreement1} onChange={this.handleInputChange} />
                                <label className={"member-join"} htmlFor={"agreement1"}>{labels.step5.agreement1}</label>
                                <span className={"get-info"} onClick={() => { return this.props.showInfoModal('agreement1') }}>{this.props.getInfoModalContent("agreement1").infoIconLabel}</span>
                            </div>
                            <div>
                                <input type="checkbox" id="agreement2" name="agreement2" checked={this.props.stepState.agreement2} onChange={this.handleInputChange} />
                                <label className={"member-join"} htmlFor={"agreement2"}>{labels.step5.agreement2}</label>
                                <span className={"get-info"} onClick={() => { return this.props.showInfoModal('agreement2') }}>{this.props.getInfoModalContent("agreement2").infoIconLabel}</span>
                            </div>
                            <div>
                                <input type="checkbox" id="agreement3" name="agreement3" checked={this.props.stepState.agreement3} onChange={this.handleInputChange} />
                                <label className={"member-join"} htmlFor={"agreement3"}>{labels.step5.agreement3}</label>
                                <span className={"get-info"} onClick={() => { return this.props.showInfoModal('agreement3') }}>{this.props.getInfoModalContent("agreement3").infoIconLabel}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>;
    }
}

module.exports = Agreements;